<template>
  <div>
    <section class="support-hero">
      <div>
        <p class="eyebrow"><svg class="icon icon-inline" aria-hidden="true"><use href="#i-support"/></svg>{{ $t('intake.portal.supportHeroEyebrow') }}</p>
        <h2>{{ $t('intake.portal.supportHeroTitle') }}</h2>
        <p>{{ $t('intake.portal.supportHeroBody') }}</p>
        <p class="rb-ob-status" role="note">{{ $t('intake.portal.supportMessengerNote') }}</p>
      </div>
      <router-link class="btn btn-primary" :to="r('portalRequestNew')">{{ $t('intake.portal.supportNewCta') }}</router-link>
    </section>

    <div class="support-cats">
      <router-link v-for="cat in cats" :key="cat.key" :to="{name:'portalRequestNew',params:{lang},query:{topic:cat.topic}}">
        {{ $t('intake.portal.' + cat.labelKey) }}
      </router-link>
    </div>

    <div class="section-intro"><h2><svg class="icon" aria-hidden="true"><use href="#i-bell"/></svg>{{ $t('intake.portal.supportOpen') }}</h2></div>
    <p v-if="needsLogin" class="rb-ob-status" role="status">{{ $t('intake.portal.needsLogin') }}</p>
    <p v-else-if="loading" class="rb-ob-status" role="status">{{ $t('intake.portal.loading') }}</p>
    <div v-else-if="error" class="rb-ob-status" role="alert">
      <p>{{ $t('intake.portal.loadError') }}</p>
      <button class="btn btn-secondary" @click="bootstrap(currentPage)">{{ lang === 'fa' ? 'تلاش دوباره' : 'Try again' }}</button>
    </div>
    <p v-else-if="!items.length" class="rb-ob-status" role="status">{{ $t('intake.portal.supportEmpty') }}</p>

    <div v-else class="list">
      <article v-for="item in items" :key="item.id" class="list-card">
        <div class="copy"><h3>{{ topicLabel(item.topic) }}</h3><p>{{ item.meta }}</p></div>
        <div class="list-actions">
          <span :class="['status', statusTone(item.status)]">{{ statusLabel(item.status) }}</span>
          <router-link class="btn btn-secondary btn-sm" :to="detailLink(item)">{{ $t('intake.portal.details') }}</router-link>
        </div>
      </article>
    </div>
    <nav v-if="lastPage > 1" class="actions" :aria-label="lang === 'fa' ? 'صفحه‌های درخواست‌ها' : 'Request pages'">
      <button class="btn btn-secondary" :disabled="loading || currentPage <= 1" @click="bootstrap(currentPage - 1)">{{ lang === 'fa' ? 'قبلی' : 'Previous' }}</button>
      <span aria-live="polite">{{ currentPage }} / {{ lastPage }}</span>
      <button class="btn btn-secondary" :disabled="loading || currentPage >= lastPage" @click="bootstrap(currentPage + 1)">{{ lang === 'fa' ? 'بعدی' : 'Next' }}</button>
    </nav>
  </div>
</template>

<script>
import {
  fetchSupportRequests,
  hasAuthToken,
  supportRequestAsListItem,
  supportStatusI18nKey,
  supportStatusTone,
  supportTopicI18nKey,
} from '@/intake/portalApi'

export default {
  name: 'PortalSupportStep',
  data() {
    return {
      loading: true,
      needsLogin: false,
      items: [],
      error: false,
      currentPage: 1,
      lastPage: 1,
      cats: [
        {key:'c1',topic:'BOOKING',labelKey:'supportCat1'},
        {key:'c2',topic:'PAYMENT',labelKey:'supportCat2'},
        {key:'c3',topic:'ACCESS',labelKey:'supportCat3'},
        {key:'c4',topic:'DELIVERY',labelKey:'requestTopic_delivery'},
      ],
    }
  },
  computed: {lang() { return this.$route.params.lang || 'fa' }},
  mounted() { this.bootstrap() },
  methods: {
    r(name) { return {name, params:{lang:this.lang}} },
    detailLink(item) { return {name:'portalRequestDetail',params:{lang:this.lang},query:{id:String(item.id)}} },
    topicLabel(topic) {
      const key = supportTopicI18nKey(topic)
      const value = this.$t(key)
      return value === key ? topic : value
    },
    statusLabel(status) {
      const key = supportStatusI18nKey(status)
      const value = this.$t(key)
      return value === key ? status : value
    },
    statusTone(status) {
      return supportStatusTone(status)
    },
    bootstrap(target = 1) {
      this.loading = true
      this.error = false
      this.needsLogin = !hasAuthToken()
      if (this.needsLogin) { this.loading = false; return }
      return fetchSupportRequests(target)
          .then((page) => {
            const items = ((page && page.data) || []).map((r) => supportRequestAsListItem(r, this.lang)).filter(Boolean)
            items.sort((a, b) => {
              const ao = String(a.status).toUpperCase() === 'OPEN' ? 0 : 1
              const bo = String(b.status).toUpperCase() === 'OPEN' ? 0 : 1
              return ao - bo
            })
            this.items = items
            this.currentPage = Number(page.current_page) || 1
            this.lastPage = Number(page.last_page) || 1
          })
          .catch(() => { this.error = true })
          .finally(() => { this.loading = false })
    },
  },
}
</script>
